import axios from "axios";
import { Form } from "devextreme-react";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import DataSource from "devextreme/data/data_source";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { claim } from "../../data";
import {
  // update1,
  // update2,
  // update3,
  // update4,
  // update5,
  // update6,
  // update7,
  // update9,
  updateApprDate,
  updateClaim,
  updateClaimDate,
  updateCmt,
  updateDetailedCmt,
  updateSiteNo,
  updateSubmDate,
  updateTaskCodeId,
  updateTaskCodeListId,
} from "../Redux/IRBTask";

const TaskFormWrapper = styled.div`
  .dx-field-item-required-mark {
    color: red;
  }

  .dx-datebox-calendar .dx-dropdowneditor-icon::before {
    content: "\f026";
  }
`;

export default function TaskForm(props) {
  const { contrNo, IRBTask, formTaskRef } = props;

  const [taskDataSource, setTaskDataSource] = useState(null);
  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/common/codeList?name=IRB Submission&cat=13`
    );

    setTaskDataSource(result.data.code);

    dispatch(
      updateTaskCodeListId({
        taskCodeListId: result.data.codeListId,
      })
    );
  }, []);

  const [detailedCmtDataSource, setDetailedCmtDataSource] = useState(null);
  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/detailedCmt`
    );

    setDetailedCmtDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: "detailedCmt",
        },
      })
    );
  }, []);

  const [siteDataSource, setSiteDataSource] = useState(null);
  useEffect(async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/irb/siteInfo/${contrNo}`
    );

    setSiteDataSource(
      new DataSource({
        store: {
          data: result.data,
          type: "array",
          key: "siteNo",
        },
      })
    );
  }, [contrNo]);

  const dispatch = useDispatch();

  const onSiteNoValueChanged = (e) => {
    dispatch(
      updateSiteNo({
        siteNo: e.value,
      })
    );
  };

  const onClaimDateValueChanged = (e) => {
    dispatch(
      updateClaimDate({
        claimDate: e.value ? e.value : null,
      })
    );
  };

  const onClaimValueChanged = (e) => {
    dispatch(
      updateClaim({
        claim: e.value ? e.value : null,
      })
    );
  };

  const onTaskCodeIdValueChanged = (e) => {
    dispatch(
      updateTaskCodeId({
        taskCodeId: e.value,
      })
    );
  };

  const onDetailedCmtValueChanged = (e) => {
    dispatch(updateDetailedCmt({ detailedCmt: e.value }));
  };

  const onSubmDateValueChanged = (e) => [
    dispatch(
      updateSubmDate({
        submDate: e.value,
      })
    ),
  ];

  const onApprDateValueChanged = (e) => {
    dispatch(
      updateApprDate({
        apprDate: e.value ? e.value : null,
      })
    );
  };

  // const on1ValueChanged = (e) => {
  //   dispatch(
  //     update1({
  //       1: e.value ? e.value : null,
  //     })
  //   );
  // };

  // const on2ValueChanged = (e) => {
  //   dispatch(
  //     update2({
  //       2: e.value ? e.value : null,
  //     })
  //   );
  // };

  // const on3ValueChanged = (e) => {
  //   dispatch(
  //     update3({
  //       3: e.value ? e.value : null,
  //     })
  //   );
  // };

  // const on4ValueChanged = (e) => {
  //   dispatch(
  //     update4({
  //       4: e.value ? e.value : null,
  //     })
  //   );
  // };

  // const on5ValueChanged = (e) => {
  //   dispatch(
  //     update5({
  //       5: e.value ? e.value : null,
  //     })
  //   );
  // };

  // const on6ValueChanged = (e) => {
  //   dispatch(
  //     update6({
  //       6: e.value ? e.value : null,
  //     })
  //   );
  // };

  // const on7ValueChanged = (e) => {
  //   dispatch(
  //     update7({
  //       7: e.value ? e.value : null,
  //     })
  //   );
  // };

  // const on9ValueChanged = (e) => {
  //   dispatch(
  //     update9({
  //       9: e.value ? e.value : null,
  //     })
  //   );
  // };

  const onCmtValueChanged = (e) => {
    dispatch(
      updateCmt({
        cmt: e.value ? e.value : null,
      })
    );
  };

  const itemRender = ({ siteNo, yadmNm, INSPCT_MANAGER_NAME }) => {
    return (
      <div>
        {/* {siteNo}-{LAB_NAME}-{INSPCT_MANAGER_NAME} */}
        {siteNo}-{yadmNm}-{INSPCT_MANAGER_NAME}
      </div>
    );
  };

  const displayExpr = (item) => {
    if (item) {
      // return `${item.siteNo}-${item.LAB_NAME}-${item.INSPCT_MANAGER_NAME}`;
      return `${item.siteNo}-${item.yadmNm}-${item.INSPCT_MANAGER_NAME}`;
    } else {
      return null;
    }
  };

  const onCustomItemCreating = (args) => {
    if (!args.text) {
      args.customItem = null;

      return;
    }

    if (detailedCmtDataSource) {
      const newItem = {
        detailedCmt: args.text,
      };

      args.customItem = detailedCmtDataSource
        .store()
        .insert(newItem)
        .then(() => detailedCmtDataSource.load())
        .then(() => newItem)
        .catch((error) => {
          throw error;
        });
    }
  };

  return (
    <TaskFormWrapper>
      <Form
        id="form-Task"
        ref={formTaskRef}
        colCount={4}
        labelMode="outside"
        labelLocation="top"
        showColonAfterLabel={true}
        style={{
          padding: "16px",
        }}
        validationGroup="taskData"
      >
        <SimpleItem
          dataField={"siteNo"}
          colSpan={2}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: siteDataSource,
            // displayExpr: "LAB_NAME",
            valueExpr: "siteNo",
            showClearButton: true,
            value: IRBTask.siteNo,
            readOnly: IRBTask.action == "insert" ? false : true,
            itemRender: itemRender,
            displayExpr: displayExpr,
            onValueChanged: onSiteNoValueChanged,
          }}
        >
          <Label text={"Site Info."} />
          <RequiredRule message={"Site info. is required."} />
        </SimpleItem>
        {/* <EmptyItem /> */}
        <SimpleItem
          dataField={"claim"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: claim,
            valueExpr: "id",
            displayExpr: "name",
            value: IRBTask.claim,
            showClearButton: true,
            defaultValue: "Y",
            onValueChanged: onClaimValueChanged,
          }}
        >
          <Label text={"청구/미청구"} />
        </SimpleItem>
        <SimpleItem
          dataField={"claimDate"}
          // editorType={"dxDateBox"}
          editorType={"dxTextBox"}
          editorOptions={{
            value: IRBTask.claimDate,
            // displayFormat: "yyyy-MM-dd",
            // dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            // useMaskBehavior: true,
            readOnly: IRBTask.claim == "N" ? true : false,
            onValueChanged: onClaimDateValueChanged,
          }}
        >
          <Label text={"청구일"} />
        </SimpleItem>
        <SimpleItem
          dataField={"taskCodeId"}
          editorType={"dxSelectBox"}
          editorOptions={{
            dataSource: taskDataSource,
            valueExpr: "codeId",
            displayExpr: "name",
            value: IRBTask.taskCodeId,
            showClearButton: true,
            onValueChanged: onTaskCodeIdValueChanged,
          }}
        >
          <Label text={"Task"} />
          <RequiredRule message={"Task is required."} />
        </SimpleItem>
        <SimpleItem
          dataField={"detailedCmt"}
          editorType={"dxSelectBox"}
          editorOptions={{
            // dataSource: detailedCmt,
            dataSource: detailedCmtDataSource,
            valueExpr: "detailedCmt",
            displayExpr: "detailedCmt",
            value: IRBTask.detailedCmt,
            showClearButton: true,
            acceptCustomValue: true,
            searchEnabled: true,
            onValueChanged: onDetailedCmtValueChanged,
            onCustomItemCreating: onCustomItemCreating,
          }}
        >
          <Label text={"Detailed Comment"} />
          {/* <RequiredRule message={"Detailed comment is required."} /> */}
        </SimpleItem>
        <SimpleItem
          dataField={"submDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: IRBTask.submDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            onValueChanged: onSubmDateValueChanged,
          }}
        >
          <Label text={"Submission Date"} />
          <RequiredRule message={"Submission date is required"} />
        </SimpleItem>
        <SimpleItem
          dataField={"apprDate"}
          editorType={"dxDateBox"}
          editorOptions={{
            value: IRBTask.apprDate,
            displayFormat: "yyyy-MM-dd",
            dateSerializationFormat: "yyyy-MM-dd",
            showClearButton: true,
            useMaskBehavior: true,
            onValueChanged: onApprDateValueChanged,
          }}
        >
          <Label text={"Approval Date"} />
        </SimpleItem>
        {/* <GroupItem caption={"Number of Time"} colSpan={4} colCount={4}>
        <SimpleItem
          dataField={"1"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: IRBTask["1"],
            showClearButton: true,
            onValueChanged: on1ValueChanged,
          }}
        >
          <Label text={"Initial"} />
        </SimpleItem>
        <SimpleItem
          dataField={"2"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: IRBTask["2"],
            showClearButton: true,
            onValueChanged: on2ValueChanged,
          }}
        >
          <Label text={"Major"} />
        </SimpleItem>
        <SimpleItem
          dataField={"3"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: IRBTask["3"],
            showClearButton: true,
            onValueChanged: on3ValueChanged,
          }}
        >
          <Label text={"Minor"} />
        </SimpleItem>
        <SimpleItem
          dataField={"4"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: IRBTask["4"],
            showClearButton: true,
            onValueChanged: on4ValueChanged,
          }}
        >
          <Label text={"Interim"} />
        </SimpleItem>
        <SimpleItem
          dataField={"5"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: IRBTask["5"],
            showClearButton: true,
            onValueChanged: on5ValueChanged,
          }}
        >
          <Label text={"Comp."} />
        </SimpleItem>
        <SimpleItem
          dataField={"6"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: IRBTask["6"],
            showClearButton: true,
            onValueChanged: on6ValueChanged,
          }}
        >
          <Label text={"CSR"} />
        </SimpleItem>
        <SimpleItem
          dataField={"7"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: IRBTask["7"],
            showClearButton: true,
            onValueChanged: on7ValueChanged,
          }}
        >
          <Label text={"PT Deviation"} />
        </SimpleItem>
        <SimpleItem
          dataField={"9"}
          editorType={"dxNumberBox"}
          editorOptions={{
            value: IRBTask["9"],
            showClearButton: true,
            onValueChanged: on9ValueChanged,
          }}
        >
          <Label text={"Other"} />
        </SimpleItem>
      </GroupItem> */}
        <SimpleItem
          dataField={"cmt"}
          editorType={"dxTextArea"}
          editorOptions={{
            value: IRBTask.cmt,
            showClearButton: true,
            onValueChanged: onCmtValueChanged,
          }}
          colSpan={4}
        >
          <Label text={"Comment"} />
        </SimpleItem>
      </Form>
    </TaskFormWrapper>
  );
}
